import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import axiosInstance from "../../utils/axiosConfig";

function AdminDashboard() {
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateMessage, setUpdateMessage] = useState("");

  const handleUpdateL2Dates = async () => {
    setIsUpdating(true);
    setUpdateMessage("");
    
    try {
      const response = await axiosInstance.post("/adminpage/update-l2-dates");
      setUpdateMessage(`Success: ${response.data.message} (${response.data.affectedRows} rows affected)`);
    } catch (error) {
      console.error("Error updating L2 dates:", error);
      setUpdateMessage(`Error: ${error.response?.data?.error || "Failed to update L2 dates"}`);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Header />
      <main className="flex-grow flex justify-center items-center p-6">
        <div className="bg-white shadow-md rounded-lg p-8 max-w-lg w-full text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            Admin Actions
          </h2>
          <div className="space-y-4">
            <Link
              to="/admin/user"
              className="block w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Manage Users
            </Link>
            <Link
              to="/admin/master-access"
              className="block w-full bg-purple-600 text-white py-3 rounded-lg hover:bg-purple-700 transition"
            >
              Grant Master Access
            </Link>
            <Link
              to="/merge-indent"
              className="block w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Merge Indents
            </Link>
            <Link
              to="/admin/project_head"
              className="block w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Project Team Management
            </Link>
           {/* <Link
              to="/admin/store_officer"
              className="block w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Store Officer
            </Link> */}
            <Link
              to="/admin/period"
              className="block w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition"
            >
              Manage Indent Periods
            </Link>
            <Link
              to="/admin/query-analyzer"
              className="block w-full bg-yellow-600 text-white py-3 rounded-lg hover:bg-purple-700 transition"
            >
              Filter
            </Link>
            <Link
              to="/admin/revert-indent"
              className="block w-full bg-green-700 text-white py-3 rounded-lg hover:bg-yellow-700 transition"
            >
              Revert Indent Status
            </Link>
            <Link
              to="/admin/delete-indents"
              className="block w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition"
            >
              Delete Indents
            </Link>
            
            {/* Update L2 Dates Button */}
            <button
              onClick={handleUpdateL2Dates}
              disabled={isUpdating}
              className={`block w-full py-3 rounded-lg transition ${
                isUpdating 
                  ? "bg-gray-400 cursor-not-allowed" 
                  : "bg-orange-600 hover:bg-orange-700"
              } text-white`}
            >
              {isUpdating ? "Updating..." : "Update L2 Dates"}
            </button>
            
            {/* Update Message */}
            {updateMessage && (
              <div className={`p-3 rounded-lg text-sm ${
                updateMessage.startsWith("Success") 
                  ? "bg-green-100 text-green-800" 
                  : "bg-red-100 text-red-800"
              }`}>
                {updateMessage}
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

export default AdminDashboard;
